export default {
	InvitationCode: "Codice di Invito",
	CreditScore: "Punteggio di Credito",
	MyFinancial: {
		title: "Le Mie Finanze",
		menu: ["Deposito", "Prelievo", "Transazione"]
	},
	MyDetail: {
		title: "Il Mio Dettaglio",
		menu: ["Informazioni Personali", "Metodi di Pagamento"]
	},
	Other: {
		title: "Altro",
		menu: ["Contattaci", "Notifiche", "Cambia Lingua"]
	},
	Amount: ["Saldo del Portafoglio", "Saldo Congelato", "Guadagni di Oggi"],
	Logout: {
		title: "Disconnetti",
		content: "Sei sicuro di voler disconnetterti?"
	}
};
